import styled, { css } from 'styled-components';
import { variables } from '../theme/variables';
import { NavLink } from 'react-router-dom';
import {
  cardBackgroundColor,
  cardTitleColor,
  cardBorderColor,
  itemTextColor,
  cardWrapperBackgroundColor,
  cardWrapperBorderColor,
  cardButtonBorderColor,
  mainCardTextColor
} from 'utils/theme';

export const ShowcaseDate = styled.div`
  top: 14px;
  left: 14px;
  font-size: 13px;
  border-radius: 8px;
  text-align: center;
  position: absolute;
  background-color: ${variables.colors.white};
  padding: 8.48px 7.75px 10.52px 8.39px;
  ${variables.fonts.openSansSemiBold};
  box-shadow: 0 3px 11px rgba(0, 0, 0, 0.16);

  span {
    display: block;
  }

  img {
  }

  sup {
    position: relative;
    top: 14px;
    left: 2px;
  }

  .showcase-date-day {
    color: ${variables.colors.grey4};
  }

  .showcase-date-Date {
    font-size: 22px;
    line-height: 1.1;
  }

  .showcase-date-month {
    color: ${variables.colors.brown1};
  }
`;

export const LinkWrapper = styled(NavLink)`
  color: inherit;
  display: block;
  text-decoration: none;
  // height: 428px;
  overflow: hidden;
  background-color: ${variables.colors.white};
  box-shadow: 0;
  transition: all 0.3s ease-in-out;
  // border-radius: 14px 14px 4px 4px;
  border: 2px solid ${cardBorderColor};

  &:hover {
    box-shadow: 0 6px 7px rgba(0, 0, 0, 0.16);

    h5 {
      color: ${cardTitleColor};
    }

    svg {
      fill: ${cardTitleColor};
    }
  }

  @media (max-width: 658px) {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
`;

export const MainCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover ${ShowcaseDate} {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.2s, opacity 0.2s linear;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  background: ${cardWrapperBackgroundColor};
  border: 1px solid ${cardWrapperBorderColor};
  border-radius: 14px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
  box-shadow: 0;

  &:hover {
    border-color: ${cardWrapperBackgroundColor};
    box-shadow: 0 3px 11px rgba(0, 0, 0, 0.16);
  }
`;

export const CardMain = styled.div`
  width: 85%;
  padding: 28px 28px 10px;
  border-right: 1px solid ${cardButtonBorderColor};

  @media screen and (max-width: 576px) {
    padding: 21px 21px 10px;
  }

  ${({ iframe }) =>
    iframe &&
    css`
      @media screen and (min-width: 1100px) {
        width: 90%;
      }
    `}
`;

export const CardAside = styled.div`
  width: 15%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;

  ${({ iframe }) =>
    iframe &&
    css`
      @media screen and (min-width: 1100px) {
        width: 10%;
      }
    `}
`;

export const CardButton = styled.button`
  background: ${cardWrapperBackgroundColor};
  border: 1px solid ${cardButtonBorderColor};
  border-radius: 7px;
  padding: 0.25em;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
      border: 1px solid ${variables.colors.grey12};
    `}

  svg {
    fill: ${cardTitleColor};
    vertical-align: middle;
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 14px;

  h4 {
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
  }

  p {
    font-size: 16px;
  }
`;

export const CardBody = styled.div`
  margin: 14px 0px;

  p {
    line-height: 1.4;
  }
`;

export const CardFooter = styled.div`
  p {
    color: ${variables.colors.red1};
  }

  button {
    color: ${itemTextColor};
  }
`;

export const ImageWrapper = styled.div`
  height: 328px;
  max-height: 328px;
  background: url(${({ img }) => img}) ${cardBackgroundColor} no-repeat center
    center/cover;
  overflow: hidden;
`;

export const PlayButton = styled.button`
  height: 0px;
  position: relative;
  top: 14px;
  left: 14px;
  z-index: 4;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;

  img {
    width: 56.44px;
    height: 56.44px;
    left: -20px;
    transition: all 0.19s ease;
    transform: scale(0.9);
    vertical-align: middle;

    &:hover {
      transform: scale(1.05);
    }
  }
`;

export const MainCardBody = styled.div`
  padding: 14px 20px;
  // max-height: 110px;
  // height: 110px;
  overflow: hidden;
  line-height: 1.4;
  background: ${cardBackgroundColor};

  .flex {
    justify-content: space-between;
    display: flex;
  }

  h4 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 94%;
    color: ${cardTitleColor};
    transition: all 0.3s ease-in-out;
    ${variables.fonts.openSansSemiBold};
    font-size: 16px;
  }

  h6,
  h5 {
    color: ${mainCardTextColor};
    transition: all 0.3s ease-in-out;
  }

  .ellipsis {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .capitalize {
    text-transform: capitalize;
    margin-top: 2px;
  }

  .font-weight-normal {
    font-weight: normal;
  }

  svg {
    fill: ${mainCardTextColor};
    transition: all 0.3s ease-in-out;
  }
`;

export const EventHeading = styled.h4`
  text-transform: uppercase;
`;

export const DigitalContentCardBody = styled.div`
  max-height: 110px;
`;

export const MusicPlayBtn = styled.button`
  box-shadow: 0 3px 11px rgba(0, 0, 0, 0.16);
  height: 42px;
  width: 42px;
  border-radius: 24px;
  background-color: white;
  position: absolute;
  top: 14px;
  left: 14px;

  svg {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 50px;
    height: 50px;
    fill: white;
  }
`;

export const ImageCard = styled.img`
  width: 372px;
  height: 372px;
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 14px 13px !important;
  @media (max-width: 768px) {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }
`;

export const CardWrapperPadding = styled.div`
 @media (max-width: 768px) {
 img{
 height: 280px !important;
 width: 280px !important;
 }
`;

export const Interpunct = '·';

export default MainCard;
